import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, switchMap, filter, take } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    private isRefreshing = false;
    private refreshTokenSubject = new BehaviorSubject<boolean>(false);

    constructor(private authenticationService: AuthenticationService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        request = request.clone({
            withCredentials: true,
        });


        return next.handle(request).pipe(
            catchError((error) => {
                if (
                    error instanceof HttpErrorResponse &&
                    !request.url.includes('login') &&
                    !request.url.includes('refresh') &&
                    !request.url.includes('logout') &&
                    error.status === 401
                ) {
                    return this.handle401Error(request, next);
                }

                return throwError(() => error);
            })
        );
    }


    private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
        if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.refreshTokenSubject.next(false);

            if (this.authenticationService.currentUserValue) {
                return this.authenticationService.refresh().pipe(
                    switchMap((result) => {
                        if (!result?.success || !result?.user) {
                            this.isRefreshing = false;
                            this.refreshTokenSubject.next(false);
                            this.authenticationService.handleSessionExpired();
                            return throwError(() => new Error('Session expired'));
                        }

                        this.isRefreshing = false;
                        this.refreshTokenSubject.next(true);
                        return next.handle(request);
                    }),
                    catchError(() => {
                        this.isRefreshing = false;
                        this.refreshTokenSubject.next(false);
                        this.authenticationService.handleSessionExpired();
                        return throwError(() => new Error('Session expired'));
                    })
                );
            }

            this.isRefreshing = false;
            this.refreshTokenSubject.next(false);
            this.authenticationService.handleSessionExpired();
            return throwError(() => new Error('Session expired'));
        }

        return this.refreshTokenSubject.pipe(
            filter((status) => status === true),
            take(1),
            switchMap(() => next.handle(request))
        );
    }
}
